import React from "react";
import { Container, Grid } from "@mui/material";

import StatementListItem from "./StatementListItem";

const ListArray = [
    {
        uuid: "d290f1ee-6c54-4b01-90e6-d701748f085",
        label: "360 Patient feedback report",
        status: "active",
        dateStart: "2020-05-05 12:00:00",
        dateEnd: "2020-06-05 12:00:00",
        requester: {
        },
        recipients: {
        }
    },
    {
        uuid: "d290f1ee-6c54-4b01-90e6-d701748f086",
        label: "360 Patient feedback report",
        status: "active",
        dateStart: "2020-07-04 12:00:00",
        dateEnd: "2021-08-04 12:00:00",
        requester: {
        },
        recipients: {
        }
    },
    {
        uuid: "d290f1ee-6c54-4b01-90e6-d701748f087",
        label: "360 Patient feedback report",
        status: "active",
        dateStart: "2020-05-04 12:00:00",
        dateEnd: "2021-12-04 12:00:00",
        requester: {
        },
        recipients: {
        }
    },
    {
        uuid: "d290f1ee-6c54-4b01-90e6-d701748f088",
        label: "360 Patient feedback report",
        status: "active",
        dateStart: "2020-05-04 12:00:00",
        dateEnd: "2025-12-04 12:00:00",
        requester: {
        },
        recipients: {
        }
    },
];


function StatementList () {

    return (
        <Container className="content">
            <Grid container spacing={3}>
                { ListArray && ListArray.length && ListArray.map((data) => (
                    <Grid item xs={12} key={data.uuid}>
                        <StatementListItem data={data} />
                    </Grid>
                ))
                }
            </Grid>
        </Container>
    )
}

export default StatementList;